import BaseCRUDService from './BaseCRUDService';

class DistributorService extends BaseCRUDService {
  getBaseURL = () => {
    return '~/api/distributor';
  };
}

export default new DistributorService();
